import {
    ApplicantEmploymentState,
    ApplicantHomeState,
    ApplicantPersonalState,
    CalculatorTurboCashStepViewFieldErrorState,
    CalculatorTurboCashStepViewState,
    FilesState,
    HomeDataTurboCashStepViewFieldErrorState,
    HomeDataTurboCashStepViewState,
    HomeFileState,
    IdentificationFileState,
    OtherFileState,
    PersonalDataTurboCashStepViewFieldErrorState,
    PersonalDataTurboCashStepViewState,
    ReferenceState,
    SummaryState,
    WorkDataTurboCashStepViewErrorFieldState,
    WorkDataTurboCashStepViewState,
    CalculatorState,
    TurboCashLoanApplicationState,
    TurboCashUIState, OtherReferencesState, TempDataReference, TempDataReferenceState, CarLicenceFileState
} from '../types/mx/turboCash/reducers';
import * as ValidateConstant from './ValidateConstant';
import {calculatorInit} from './CalculatorInit';
import {TurboCashBankApplication} from '../types/mx/reducers';

export const TurboCashInit: TurboCashBankApplication = {
    calculator: calculatorInit as CalculatorState,
    loanApplication: {
        currentStep: 0,
        highestStep: 0,
        applicantPersonal: {
            firstName: '',
            secondName: '',
            lastName: '',
            secondLastName: '',
            birthDate: '',
            docNumber: '',
            cellPhone: '',
            email: '',
            civilStatus: {
                id: '',
                value: ''
            },
            regime: {
                id: '',
                value: ''
            },
            rolHome: {
                id: '',
                value: ''
            },
            studies: {
                id: '',
                value: ''
            },
            houseType: {
                id: '',
                value: ''
            },
            amountDependents: '',
            cURP: '',
            houseHoldTime: {
                id: '',
                value: ''
            },
            houseHoldMeasure: {
                id: '',
                value: ''
            }
        } as ApplicantPersonalState,
        applicantHome: {
            address: '',
            extNumber: '',
            intNumber: '',
            postalCode: '',
            state: {
                id: '',
                value: ''
            },
            city: {
                id: '',
                value: ''
            },
            municipality: {
                id: '',
                value: ''
            },
            colonies: [],
            selectedColony: {
                id: '',
                value: ''
            },
            phone: ''
        } as ApplicantHomeState,
        applicantEmployment: {
            workplaceName: '',
            position: '',
            workingSince: '',
            employmentRotation: {
                id: '',
                value: ''
            },
            address: '',
            extNumber: '',
            intNumber: '',
            streetBetween: '',
            workplacePhone: '',
            workplacePhoneExt: '',
            monthlyIncomes: '',
            postalCode: '',
            state: {
                id: '',
                value: ''
            },
            city: {
                id: '',
                value: ''
            },
            municipality: {
                id: '',
                value: ''
            },
            colonies: [],
            selectedColony: {
                id: '',
                value: ''
            },
        } as ApplicantEmploymentState,
        otherReferences: {
            tempDataReference: {
                index: 0,
                data: {} as TempDataReference
            } as TempDataReferenceState,
            references: [] as ReferenceState[]
        } as OtherReferencesState,
        token: '',
        createdAt: null,
        summary: {
            desiredVehicle: '',
            price: '',
            downPayment: '',
            term: '',
            amountFinance: '',
            detailCommission: '',
            monthlyPayment: '',
            monthlyInsurance: '',
        } as SummaryState,
        files: {
            identification: {
                ifeFrontFiles: [],
                ifeBackFiles: []
            } as IdentificationFileState,
            home: {
                homeFiles: []
            } as HomeFileState,
            other: {
                otherMonth1Files: [],
                otherMonth2Files: [],
                otherMonth3Files: []
            } as OtherFileState,
            carLicence: {
                carLicenceFrontFiles: [],
                carLicenceBackFiles: []
            } as CarLicenceFileState,
        } as FilesState
    } as TurboCashLoanApplicationState,
    ui: {
        personalDataStepView: {
            fieldErrors: {
                firstNameFieldError: ValidateConstant.ERROR_REQUIRED,
                secondNameFieldError: null,
                lastNameFieldError: ValidateConstant.ERROR_REQUIRED,
                secondLastNameFieldError: ValidateConstant.ERROR_REQUIRED,
                birthDateFieldError: ValidateConstant.ERROR_REQUIRED,
                docNumberFieldError: ValidateConstant.ERROR_REQUIRED,
                cellPhoneFieldError: ValidateConstant.ERROR_REQUIRED,
                civilStatusFieldError: ValidateConstant.ERROR_REQUIRED,
                regimeFieldError: ValidateConstant.ERROR_REQUIRED,
                rolHomeFieldError: ValidateConstant.ERROR_REQUIRED,
                studiesFieldError: ValidateConstant.ERROR_REQUIRED,
                houseTypeFieldError: ValidateConstant.ERROR_REQUIRED,
                amountDependentsFieldError: ValidateConstant.ERROR_REQUIRED,
                cURPFieldError: ValidateConstant.ERROR_REQUIRED
            } as PersonalDataTurboCashStepViewFieldErrorState
        } as PersonalDataTurboCashStepViewState,
        calculatorStepView: {
            fieldErrors: {
                yearFieldError: null,
                brandFieldError: ValidateConstant.ERROR_REQUIRED,
                modelFieldError: ValidateConstant.ERROR_REQUIRED,
                versionFieldError: ValidateConstant.ERROR_REQUIRED,
                provinceFieldError: ValidateConstant.ERROR_REQUIRED,
                assemblyCountryFieldError: ValidateConstant.ERROR_REQUIRED,
                priceFieldError: null,
                downPaymentFieldError: null,
                monthlyPaymentFieldError: null,
            } as CalculatorTurboCashStepViewFieldErrorState
        } as CalculatorTurboCashStepViewState,
        homeDataStepView: {
            hasPostalCodeError: false,
            fieldErrors: {
                addressFieldError: ValidateConstant.ERROR_REQUIRED,
                extNumberFieldError: ValidateConstant.ERROR_REQUIRED,
                intNumberFieldError: null,
                postalCodeFieldError: ValidateConstant.ERROR_REQUIRED,
                stateFieldError: ValidateConstant.ERROR_REQUIRED,
                cityFieldError: null,
                municipalityFieldError: ValidateConstant.ERROR_REQUIRED,
                selectedColonyFieldError: ValidateConstant.ERROR_REQUIRED,
                phoneFieldError: ValidateConstant.ERROR_REQUIRED,
            } as HomeDataTurboCashStepViewFieldErrorState
        } as HomeDataTurboCashStepViewState,
        workDataStepView: {
            hasPostalCodeError: false,
            fieldErrors: {
                workplaceNameFieldError: ValidateConstant.ERROR_REQUIRED,
                positionFieldError: ValidateConstant.ERROR_REQUIRED,
                workingSinceFieldError: ValidateConstant.ERROR_REQUIRED,
                employmentRotationFieldError: ValidateConstant.ERROR_REQUIRED,
                addressFieldError: ValidateConstant.ERROR_REQUIRED,
                extNumberFieldError: ValidateConstant.ERROR_REQUIRED,
                intNumberFieldError: null,
                streetBetweenFieldError: ValidateConstant.ERROR_REQUIRED,
                workplacePhoneFieldError: ValidateConstant.ERROR_REQUIRED,
                workplacePhoneExtError: null,
                postalCodeFieldError: ValidateConstant.ERROR_REQUIRED,
                stateFieldError: ValidateConstant.ERROR_REQUIRED,
                cityFieldError: null,
                municipalityFieldError: ValidateConstant.ERROR_REQUIRED,
                selectedColonyFieldError: ValidateConstant.ERROR_REQUIRED,
                monthlyIncomesFieldError: ValidateConstant.ERROR_REQUIRED,
            } as WorkDataTurboCashStepViewErrorFieldState
        } as WorkDataTurboCashStepViewState
    } as TurboCashUIState
};
